import Table from "../../../Components/Table/Table";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { isoToJalali } from "../../../helper/isoToJalali";
import { useNavigate } from "react-router-dom";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import { API_BASE_URL } from "../../../config/api";
import useInfinitePaginated, { appendUnique } from "../../../hooks/useInfinitePaginated";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";
import PercentageValue from "../../../Components/PercentageValue";

const REFERRAL_CHALLENGES_URL =
  `${API_BASE_URL}payment-payout/referrals/challenges/`;

export default function FriendsTable() {
  const formatUsd = (value) => {
    const amount = Number(value);
    if (Number.isNaN(amount)) {
      return "-";
    }
    return `$${amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const navigate = useNavigate();
  const {
    data: referalData,
    initialLoading: accLoading,
    loadingMore: isLoadingMore,
    error,
    hasNext,
    sentinelRef,
    scrollRootRef,
    retry,
  } = useInfinitePaginated({
    endpoint: REFERRAL_CHALLENGES_URL,
    navigate,
    merge: (current, incoming) => appendUnique(current, incoming, (item) => item?.id ?? item?.uuid ?? `${item?.created_at}|${item?.friend_name}|${item?.challenge_name}|${item?.commission_amount_usd}`),
  });

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <h3 className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
          لیست چالش‌های دوستان
        </h3>
      </div>

      <Table
        isEnglish={[3, 4, 5]}
        columns={[
          { key: "date", label: "تاریخ" },
          { key: "name", label: "نام" },
          { key: "challenge", label: "چالش" },
          { key: "challengePrice", label: "قیمت چالش" },
          { key: "commissionPercent", label: "درصد کمیسیون" },
          { key: "commissionAmount", label: "مبلغ کمیسیون" },
          {
            key: "status",
            label: "وضعیت",
            render: (value) =>
              value === "paid_out" ? (
                <StatusColorful
                  SVGName="tick"
                  text="برداشت شده"
                  className="w-[100px]"
                  color="blue"
                />
              ) : value === "pending" ? (
                <StatusColorful
                  SVGName="stall"
                  text="در انتظار"
                  className="w-[100px]"
                  color="yellow"
                />
              ) : value === "can_payout" ? (
                <StatusColorful
                  SVGName="tick"
                  text="قابل برداشت"
                  className="w-[100px]"
                  color="green"
                />
              ) : (
                <StatusColorful
                  SVGName="stall"
                  text="نامشخص"
                  className="w-[100px]"
                  color="gray"
                />
              ),
          },
        ]}
        data={
          referalData
            ? referalData?.map((referal) => ({
                date: referal.created_at
                  ? isoToJalali(referal.created_at)
                  : "-",
                name: referal.friend_name || "-",
                challenge: referal.challenge_name || "-",
                challengePrice: formatUsd(referal.challenge_price_usd),
                commissionPercent: (
                  <PercentageValue value={referal.commission_percent} />
                ),
                commissionAmount: formatUsd(referal.commission_amount_usd),
                status: referal.status,
              }))
            : []
        }
        scrollRootRef={scrollRootRef}
        footer={!accLoading ? <InfiniteScrollFooter sentinelRef={sentinelRef} loading={isLoadingMore} error={error} onRetry={retry} hasNext={hasNext} /> : null}
      />
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}
      {!accLoading && referalData.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}
    </div>
  );
}
